module.exports = __webpack_public_path__ + "img/主页图片3-tuya.168b55d7.png";